<template>
  <div>
    <div class="main-title">退款统计表
      <el-button-group>
        <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
        <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
        <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
      </el-button-group>
    </div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchParams)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="sqlcode" style="width:120px;" @change="search(searchParams)">
              <el-option label="按驾校统计" value="report_school_refund"></el-option>
              <el-option label="按教练统计" value="report_coach_refund"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.refund_type" style="width:120px;" placeholder="退款类型" @change="search(searchParams)">
              <el-option label="全部类型" :value="null"></el-option>
              <el-option label="预收退款" value="1"></el-option>
              <el-option label="免单退款" value="2"></el-option>
              <el-option label="租赁车退款" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="训练日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              :placeholder="sqlcode === 'report_school_refund' ? '搜索驾校名称或拼音' : '搜索教练名称或拼音'"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        style="width:100%">
        <el-table-column
          prop="school_name"
          label="驾校名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练名称"
          width="120"
          v-if="sqlcode === 'report_coach_refund'">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="累计时长"
          width="90">
        </el-table-column>
        <el-table-column
          prop="student_count"
          label="累计学员"
          width="90">
        </el-table-column>
        <el-table-column
          prop="fee"
          label="累计应收"
          width="90">
        </el-table-column>
        <!--
        <el-table-column
          prop="fee_discount"
          label="累计优惠"
          width="90">
        </el-table-column>
        -->
        <el-table-column
          prop="refund_money"
          label="累计退款"
          width="100">
        </el-table-column>
        <el-table-column
          prop="pay_total"
          label="累计实收"
          width="90">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <detail-dialog :user="user" :visible="detailVisible" :params="detailParams" @close="detailVisible = false"></detail-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
import DetailDialog from './DetailDialog'
export default {
  mixins: [ListFunc, DatePickerOptions],
  components: {
    DetailDialog
  },
  data () {
    return {
      sqlcode: 'report_school_refund',
      companyList: [],
      searchForm: {
        company_ids: [],
        query: '',
        daterange: [],
        refund_type: null
      },
      detailVisible: false,
      detailParams: {},
      sumProps: [
        'use_time',
        'fee',
        'fee_discount',
        'pay_total',
        'refund_money',
        'student_count'
      ]
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          refund_type: this.searchForm.refund_type,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  watch: {
    sqlcode (val) {
      this.refresh()
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    showDetail (row) {
      this.detailParams = {
        school_id: row.school_id,
        company_ids: this.searchForm.company_ids,
        daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
        daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      this.detailVisible = true
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (this.sumProps.indexOf(column.property) >= 0) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'school_name') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/Refund.vue